import { Fragment } from 'react';
import Dependency from './Dependency';

const ValueWithDependencies = ({ value = '', dependencies = [] }) => {
  let lastEnd = 0;

  return (
    <>
      {dependencies.map((obj, index) => {
        const preText = value.substring(lastEnd, obj?.start);
        lastEnd = obj?.end;
        const dependencyValue = value.substring(obj?.start, obj?.end);
        return (
          <Fragment key={`obj-${index}`}>
            <span>{preText}</span>
            <Dependency value={dependencyValue} dependency={obj} />
          </Fragment>
        );
      })}
      <span>{value.substring(lastEnd)}</span>
    </>
  );
};

export default ValueWithDependencies;
